import React, { useState } from 'react'
import ConnectorInfo from '../../Pages/Dashboard/ConnectorPanel/Connectors/SelectedConnector/SubComponents/ConnectorInfo'
import BusinessEntities from './BusinessEntities/BusinessEntities'
import SetupWarning from '../../Alerts/WarningComponent/SetupWarning'
import SetupAction from '../../Pages/Dashboard/ConnectorPanel/Connectors/SelectedConnector/SetupAction/SetupAction'
import { NavLink, Link } from 'react-router-dom'
import API from '../../API/API'
import '../NewConnector/Versions/Version.css'
import '../NewConnector/Questionnaires/questionnaires.css'
import { useToast } from '@chakra-ui/react'

const Details = (props) => {
    const [showTokenModal, setShowTokenModal] = useState(false);
    const [refreshToken, setRefreshToken] = useState('');
    const [loading, setLoading] = useState(false);
    const [generating, setGenerating] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [hasToken, setHasToken] = useState(false);
    const toast = useToast();

    const fetchToken = () => {
        setLoading(true);
        var accessToken = window.localStorage.getItem("accessToken");
        const headers = {
            "authorization": `Bearer ${accessToken}`,
            "content-type": "application/json"
        };
        // Using /Client/ClientRefreshToken as per latest instruction
        API.get(`/Client/ClientRefreshToken`, { headers })
            .then((response) => {
                if (response.status === 200) {
                    const token = response.data.refreshToken || response.data;
                    if (token && typeof token === 'string' && token.trim() !== '' && token !== 'Token information is not available') {
                        setRefreshToken(token);
                        setHasToken(true);
                    } else {
                        setRefreshToken('Token information is not available');
                        setHasToken(false);
                    }
                    setShowTokenModal(true);
                }
                setLoading(false);
            }).catch(err => {
                console.error(err);
                setRefreshToken('Error fetching token');
                setHasToken(false);
                setShowTokenModal(true);
                setLoading(false);
            });
    }

    const copyToken = () => {
        navigator.clipboard.writeText(refreshToken);
        toast({
            title: "Success",
            description: "Token copied to clipboard",
            status: "success",
            duration: 3000,
            isClosable: true,
            position: "top-right"
        });
    }

    const deleteToken = () => {
        if (window.confirm("Are you sure you want to delete the token?")) {
            setDeleting(true);
            var accessToken = window.localStorage.getItem("accessToken");
            const headers = {
                "authorization": `Bearer ${accessToken}`,
                "content-type": "application/json"
            };
            API.delete(`/Client/DeleteToken`, { headers })
                .then((response) => {
                    setRefreshToken("Token has been deleted");
                    setHasToken(false);
                    toast({
                        title: "Success",
                        description: "Token has been deleted",
                        status: "success",
                        duration: 3000,
                        isClosable: true,
                        position: "top-right"
                    });
                    setDeleting(false);
                }).catch(err => {
                    console.error(err);
                    toast({
                        title: "Error",
                        description: "Failed to delete token",
                        status: "error",
                        duration: 3000,
                        isClosable: true,
                        position: "top-right"
                    });
                    setDeleting(false);
                });
        }
    }

    const generateToken = () => {
        setGenerating(true);
        var accessToken = window.localStorage.getItem("accessToken");
        const headers = {
            "authorization": `Bearer ${accessToken}`,
            "content-type": "application/json"
        };

        API.get('/User/Authorize', { headers })
            .then((response) => {
                if (response.status === 200) {
                    var win = window.open(response.data, "", "width=500,height=500");
                    const pollTimer = setInterval(() => {
                        if (win.closed) {
                            clearInterval(pollTimer);
                            fetchTokenAfterGeneration();
                        }
                    }, 500);
                }
            }).catch(err => {
                console.error(err);
                toast({
                    title: "Error",
                    description: "Failed to start authorization",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "top-right"
                });
                setGenerating(false);
            });
    }

    const fetchTokenAfterGeneration = () => {
        var accessToken = window.localStorage.getItem("accessToken");
        const headers = {
            "authorization": `Bearer ${accessToken}`,
            "content-type": "application/json"
        };
        API.get(`/Client/ClientRefreshToken`, { headers })
            .then((response) => {
                const token = response.data.refreshToken || response.data;
                if (token) {
                    setRefreshToken(token);
                    setHasToken(true);
                    toast({
                        title: "Success",
                        description: "New token loaded",
                        status: "success",
                        duration: 3000,
                        isClosable: true,
                        position: "top-right"
                    });
                }
                setGenerating(false);
            }).catch(err => {
                console.error(err);
                setGenerating(false);
            });
    }

    const configuration = () => {
        localStorage.setItem("configureConnectorId", props.connectorId)
        localStorage.setItem("configureInstanceId", props.instancesId)   
    }
    return (
        <>
            <div className='col-lg-8'>
                <div className='card mndesc'>
                    <BusinessEntities
                        businessEntitiesSource={props.businessEntitiesSource}
                        businessEntitiesTarget={props.businessEntitiesTarget}
                        sourceName={props.sourceName}
                        targetName={props.targetName}
                        sourceShortName={props.sourceShortName}
                        targetShortName={props.targetShortName}
                        instancesId={props.instancesId}
                        sourceId={props.sourceId}
                        targetId={props.targetId}
                    />
                    {!props.isSetupCompleted ?
                        <>
                            {/* <SetupWarning /> */}
                        </> : null
                    }
                </div>
            </div>
            <div className='col-lg-4'>
                <div className='card mndesc'>
                    <div className="card-header">Meta Data<a className="float-right font-size-10"></a></div>
                    <div className='card-body'>
                        <ConnectorInfo
                            sourceName={props.sourceName}
                            sourceVersion={props.sourceVersion}
                            targetName={props.targetName}
                            targetVersion={props.targetVersion}
                            featureName={props.featureName}
                        />
                        <div className="otheroptions mt-1">
                            <h6> Other Options </h6>
                            {//props.isSetupCompleted ?
                                <>
                                    <div className={"actionButton"}>
                                        <SetupAction
                                            sourceType = {props.sourceType}
                                            targetType = {props.targetType}
                                            targetShortName={props.targetShortName}
                                            connectorId={props.connectorId}
                                            instancesId = {props.instancesId}
                                        />
                                         
                                    </div>
                                </> //: null
                            }
                            <Link className="customDownloadnew" to={{ pathname: "/configurations"}} onClick={configuration}>Configuration</Link>
                            <a className="customDownloadnew mt-2 d-block cursor-pointer" onClick={fetchToken}>View Token</a>
                        </div>
                    </div>
                </div>
            </div>
            {showTokenModal && (
                <div className='questionsPopup' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
                    <div className="popup_inner" style={{ top: 'auto', margin: '0', width: '60%', maxWidth: '800px' }}>
                        <div className="addPrerequisites">
                            <h3> Refresh Token </h3>
                            <div className="form-section mt-3">
                                <textarea 
                                    className="form-control" 
                                    rows="10" 
                                    readOnly 
                                    value={refreshToken}
                                    style={{ width: '100%', borderRadius: '8px', backgroundColor: '#f8f9fa' }}
                                />
                                {generating && (
                                    <div className="alert alert-info mt-2">
                                        Please complete the authorization in the popup window and close it to continue.
                                    </div>
                                )}
                                <div className="mt-3">
                                    {hasToken && (
                                        <>
                                            <button 
                                                type="button" 
                                                className="btn btn-primary mr-2" 
                                                onClick={copyToken}
                                                disabled={loading}
                                            >
                                                Copy Token
                                            </button>
                                            <button 
                                                type="button" 
                                                className="btn btn-danger mr-2" 
                                                onClick={deleteToken}
                                                disabled={deleting}
                                            >
                                                {deleting ? 'Deleting...' : 'Delete Token'}
                                            </button>
                                        </>
                                    )}
                                    {!hasToken && (
                                        <button 
                                            type="button" 
                                            className="btn btn-success mr-2" 
                                            onClick={generateToken}
                                            disabled={generating}
                                        >
                                            {generating ? 'Generating...' : 'Generate Token'}
                                        </button>
                                    )}
                                    <div className="float-right">
                                        <button 
                                            type="button" 
                                            className="btn btn-secondary waves-effect cancancel" 
                                            onClick={() => setShowTokenModal(false)}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="clearfix"></div>
                    </div>
                </div>
            )}
        </>
    )
}

export default Details